module.exports = __webpack_public_path__ + "imgs/TrevorProject.f56c150bcdbb2f048192ad87ff0e9981.png";